export default {
      id: "ic-nav-chevron-bottom-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-chevron-bottom-usage",
      toString: function () {
        return this.url;
      }
    }